import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Page from "../../../components/layouts/Page";

function HomeAdmin() {
	return (
		<Page title="Match Maker">
			<Box>
				<Typography>Àrea administració Masia el Pinatell</Typography>
			</Box>
		</Page>
	);
}

export default HomeAdmin;
